import React from "react";

export default function ExecutiveCommitteeComponent({ executiveCommittee }) {
  const committeeMembers = executiveCommittee.committeeMembers;

  // 🔹 Build rows safely (same idea as past committees structure)
  const members = [];

  if (committeeMembers.president) {
    committeeMembers.president.forEach((m) =>
      members.push({
        image: m.image,
        name: m.name,
        position: m.position,
        batch: m.batch,
        note: "By virtue of office, the Principal",
      }),
    );
  }

  if (committeeMembers.activePresident) {
    committeeMembers.activePresident.forEach((m) =>
      members.push({
        image: m.image,
        name: m.name,
        position: m.position,
        batch: m.batch,
        note: m.note,
      }),
    );
  }

  if (committeeMembers.jointSecretaries) {
    committeeMembers.jointSecretaries.forEach((m) =>
      members.push({
        image: m.image,
        name: m.name,
        position: m.position,
        batch: m.batch,
        note: m.note,
      }),
    );
  }

  if (committeeMembers.treasurer) {
    committeeMembers.treasurer.forEach((m) =>
      members.push({
        image: m.image,
        name: m.name,
        position: m.position,
        batch: m.batch,
        note: m.note,
      }),
    );
  }

  if (committeeMembers.organizer) {
    committeeMembers.organizer.forEach((m) =>
      members.push({
        image: m.image,
        name: m.name,
        position: m.position,
        batch: m.batch,
        note: m.note,
      }),
    );
  }

  if (committeeMembers.vicePresidents) {
    committeeMembers.vicePresidents.forEach((m) =>
      members.push({
        image: m.image,
        name: m.name,
        position: m.position,
        batch: m.batch,
        note: m.note,
      }),
    );
  }

  if (committeeMembers.deputySecretaries) {
    committeeMembers.deputySecretaries.forEach((m) =>
      members.push({
        image: m.image,
        name: m.name,
        position: m.position,
        batch: m.batch,
        note: m.note,
      }),
    );
  }

  if (committeeMembers.assistantTreasurer) {
    committeeMembers.assistantTreasurer.forEach((m) =>
      members.push({
        image: m.image,
        name: m.name,
        position: m.position,
        batch: m.batch,
        note: m.note,
      }),
    );
  }

  if (committeeMembers.advisor) {
    committeeMembers.advisor.forEach((m) =>
      members.push({
        image: m.image,
        name: m.name,
        position: m.position,
        batch: m.batch,
        note: m.note,
      }),
    );
  }

  if (committeeMembers.auditor) {
    committeeMembers.auditor.forEach((m) =>
      members.push({
        image: m.image,
        name: m.name,
        position: m.position,
        batch: m.batch,
        note: m.note,
      }),
    );
  }

  if (committeeMembers.committeeMembers) {
    committeeMembers.committeeMembers.forEach((m) =>
      members.push({
        image: m.image,
        name: m.name,
        position: m.position,
        batch: m.batch,
        note: m.note,
      }),
    );
  }

  return (
    <section
      style={{ backgroundColor: "#fff" }}
      data-aos="fade-right"
      id="current-executive-committee"
    >
      <div className="rounded-3 border-vcg-muted p-4">
        <h3 className="fw-bold mb-4">{executiveCommittee.name}</h3>

        <div className="table-responsive">
          <table className="table table-hover align-middle">
            {/* ✅ EXACT SAME STYLE AS YOUR OTHER TABLE */}
            <thead className="table-dark">
              <tr>
                <th></th>
                <th>Name</th>
                <th>Position</th>
                <th>Batch</th>
                <th>Note</th>
              </tr>
            </thead>

            <tbody>
              {members.map((member, idx) => (
                <tr key={idx}>
                  <td>
                    <div
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "6px",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={member.image}
                        alt={member.name}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  </td>

                  <td className="fw-semibold">{member.name || "—"}</td>

                  <td>{member.position || "—"}</td>

                  <td>{member.batch ? `Batch ${member.batch}` : "—"}</td>

                  <td className="text-muted small">{member.note || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
